import { Component } from "react";
import { reportAsyncError } from "../error-reporter";

export class ErrorBoundary extends Component<{
  children: React.ReactNode;
}> {
  state = { error: null };

  componentDidCatch(error: Error) {
    this.setState({ error });
    reportAsyncError(error);
  }

  render() {
    return this.props.children;
  }
}
